const defaultMinColWidth = 80

export function getMinColWidth(propType: string): number {
  switch (propType) {
    case 'multi-select':
      return 160
    default:
      return defaultMinColWidth
  }
}

export const collectionPageConfig = {
  minColWidth: defaultMinColWidth,
  defaultColWidth: 160,
  draggableSeamWidth: 16,
  skeletonRowCount: 8,
  skeletonTabCount: 3,
  tabHeight: 36,
  tabRenameMaxWidth: 160,
  // tabPy: 0.5,
  cellPaddingX: 8,
  cellPaddingY: 5,
}
